import moment, { Moment } from 'moment-timezone';
import { getTimezone } from '@mgm/common/utils';

const zeroPrefix = (num: number, digit: number) => {
  let zero = '';
  for (let i = 0; i < digit; i += 1) {
    zero += '0';
  }
  return (zero + num).slice(-digit);
};

const mergedDateTime = (date: moment.Moment | null, timeString: string | undefined) => {
  if (!date || !timeString) return null;

  // Parse the time string to extract hour and minute
  const [hour, minute] = timeString.split(':').map(Number);

  // Create a new moment object with the combined date and time in the specified timezone
  return moment.tz({
    year: date.year(),
    month: date.month(),
    date: date.date(), // Changed from 'day' to 'date'
    hour,
    minute,
    second: 0, // Set seconds to 0
  }, getTimezone());
};

const isBeforeToday = (date: string | Date) => moment.tz(date, getTimezone()).isBefore(moment(), 'day');

const dateFormat = (date: string | Moment, format: string) => moment(date).format(format);

const getWeeksInCurrentMonth = (date?: Moment) => {
  const startOfMonth = moment(date).startOf('month');
  const endOfMonth = moment(date).endOf('month');

  return endOfMonth.diff(startOfMonth, 'weeks', true) + 1;
};

const processShiftTimes = (
  date: Moment | null,
  startTime: Moment | null,
  endTime: Moment | null,
): { startUTC: Moment; endUTC: Moment } | null => {
  if (!date || !startTime || !endTime) {
    console.error('Date, startTime, or endTime is missing.');
    return null;
  }

  // Merge date and time in the local timezone
  const startLocal = mergedDateTime(date, startTime.format('HH:mm'));
  const endLocal = mergedDateTime(date, endTime.format('HH:mm'));

  if (!startLocal || !endLocal) {
    console.error('Failed to merge date and time.');
    return null;
  }

  // Handle overnight shift (end time on the next day)
  if (endLocal.isBefore(startLocal)) {
    endLocal.add(1, 'day');
  }

  // Convert to UTC
  const startUTC = startLocal.clone().utc();
  const endUTC = endLocal.clone().utc();

  return { startUTC, endUTC };
};

function isInRangeMoment(start: string, end: string, timeToCheck: string, timezone: string) {
  const startTime = moment.tz(start, timezone);
  const endTime = moment.tz(end, timezone);
  const time = moment.tz(timeToCheck, timezone);
  return time.isBetween(startTime, endTime, undefined, '[)');
}

export {
  zeroPrefix,
  mergedDateTime,
  dateFormat,
  isBeforeToday,
  getWeeksInCurrentMonth,
  processShiftTimes,
  isInRangeMoment,
};
